import { PVSServiceStrategy } from '@/models/PVSStrategy.ts';
import { DCSchedulePartialUpdateDto } from '@/models/doc-cirrus/DCSchedulePartialUpdateDto.ts';

import { ServiceUrl } from '@/services/ServiceURL.ts';

import { getUpdatePartialDtoPVSAppointment } from '@/utils/appointmentUtils.ts';
import { transformPatientFormDataToDocCirrusPatient } from '@/utils/patientUtils.ts';

export const doc_cirrus_service_strategy: PVSServiceStrategy = {
    createAppointmentUpdateRequest: (appointment, fields) => {
        const api_url = `${ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DOC_CIRRUS.SCHEDULES}/update`;
        const params: Record<string, string> = {
            schedule_id: appointment.id,
            instance_id: appointment.links?.dc_instance_id ?? '',
            dc_user_id: fields.patient_id ?? appointment.links?.patient_id ?? '',
        };
        const body: DCSchedulePartialUpdateDto = getUpdatePartialDtoPVSAppointment<DCSchedulePartialUpdateDto>(
            fields,
            appointment
        );

        return { body, api_url, params };
    },

    createAppointmentCancelRequest: (customer_id, instance_id, appointment, reason) => {
        const api_url: string = `${ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DOC_CIRRUS.SCHEDULES}/cancel`;
        const headers: Record<string, string | undefined> = { customer_id: customer_id };
        const params: Record<string, string | undefined> = {
            schedule_id: appointment.id,
            instance_id: instance_id,
            user_id: appointment.user_id,
            reason: reason,
            dc_user_id: appointment.links?.patient_id,
        };

        return { api_url, headers, params };
    },

    createUserFetchRequest: (user_id, instance_id) => {
        const api_url: string = `${ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DOC_CIRRUS.USERS}`;
        const params: Record<string, string | undefined> = {
            instance_id: instance_id,
            user_id: user_id,
        };

        return { api_url, params };
    },

    createUserCreateRequest: (patient_data, is_data_admission_to_pvs_approved) => {
        const api_url: string = ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DOC_CIRRUS.CREATE_USER;
        const params: Record<string, string | undefined> = {
            instance_id: patient_data.instance_id,
        };

        return {
            body: transformPatientFormDataToDocCirrusPatient(patient_data, is_data_admission_to_pvs_approved),
            api_url: api_url,
            params: params,
        };
    },

    createUserUpdateRequest: (user_id, instance_id, update_data) => {
        const api_url: string = `${ServiceUrl.PATIENT_API_DOMAIN.SECURE_ADMIN.DOC_CIRRUS.USERS}/update`;
        const params: Record<string, string | undefined> = {
            instance_id: instance_id,
            dc_user_id: user_id,
        };

        return { body: update_data, api_url: api_url, params: params };
    },

    createPvsPractitionersFetch: (instance_id) => {
        const api_url: string = ServiceUrl.PRACTITIONER_API_DOMAIN.SECURE_ADMIN.DOC_CIRRUS.USERS;
        const params: Record<string, string> = {
            instance_id: instance_id,
        };

        return { api_url, params };
    },

    createPvsAppointmentTypesFetchRequest: (instance_id) => {
        const api_url: string = ServiceUrl.PRACTITIONER_API_DOMAIN.SECURE_ADMIN.DOC_CIRRUS.SCHEDULE_TYPES;

        const params: Record<string, string> = {
            instance_id: instance_id,
        };

        return { api_url, params };
    },
};
